import set from 'lodash/set';

export const LANGUAGE_SWITCH_CLICK_ID = 'languageswitch' as const;

export type OnLanguageSelection = (languageCode: string) => void;

type DispatchLanguageSwitchSelectParams = {
  languageCode: string;
  onLanguageSelection?: OnLanguageSelection;
  isLegacyLanguageSwitchAnalyticsEnabled?: boolean;
};

export function trackLanguageSwitch(languageCode: string) {
  if (window?.digitalData && window?._satellite) {
    set(window.digitalData, 'action.clickID', LANGUAGE_SWITCH_CLICK_ID);
    set(window.digitalData, 'page.pageInfo.language', languageCode);
    window._satellite?.track?.('global_click');
  } else {
    // eslint-disable-next-line no-console
    console.warn('digitalData or _satellite not found');
  }

  return languageCode;
}

export function dispatchLanguageSwitchSelect({
  languageCode,
  onLanguageSelection,
  isLegacyLanguageSwitchAnalyticsEnabled = true,
}: DispatchLanguageSwitchSelectParams) {
  if (isLegacyLanguageSwitchAnalyticsEnabled) {
    trackLanguageSwitch(languageCode);
  }

  onLanguageSelection?.(languageCode);
  return languageCode;
}
